<template>
<div class='slide slide--assessment'>
  <div class='slide_label body-four-light'>
    {{ activity.label || $t('assessment') }}
  </div>

  <h2 class='slide_headline h-two-light'>
    {{ activity.headline }}
  </h2>

  <div
    v-if='activity.subheadline'
    class='slide_subheadline body-one-light'
    v-html='activity.subheadline'
  />

  <StateBox
    :assessmentStart='assessmentStart'
    :activity='activity'
    :slide_result='slide_result'
    :toggleActivityOverlay='toggleActivityOverlay'
  />
</div>
</template>

<script>
import CommonMixin from './common-mixin'
import StateBox from '../activity/activities/v1/Assessment/assessment-v1-state-box'

export default {
  mixins: [CommonMixin],

  components: {
    StateBox
  },

  methods: {
    assessmentStart() {
      this.toggleActivityOverlay()
    }

  }
}
</script>

<style lang='sass' scoped>
@import './assessment-v1'
</style>
